import { Heart, Lock, Users, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

// Icons remain hardcoded (they're presentational); titles + bodies come
// from i18n at render time so the strip re-renders when the user
// toggles languages.
const VALUE_KEYS = [
  { key: "written", icon: Heart },
  { key: "private", icon: Lock },
  { key: "onePhone", icon: Users },
  { key: "tenMinutes", icon: Sparkles },
] as const;

export function ValueStrip() {
  const { t } = useTranslation();
  return (
    <section
      id="value"
      className="relative px-5 py-12 sm:px-8 lg:px-12"
      data-testid="section-value"
    >
      <div className="mx-auto max-w-7xl">
        <ul className="jingle-reveal jingle-card-pine grid gap-x-8 gap-y-6 rounded-3xl px-6 py-8 sm:grid-cols-2 sm:px-10 lg:grid-cols-4">
          {VALUE_KEYS.map((v) => {
            const Icon = v.icon;
            return (
              <li key={v.key} className="flex items-start gap-3">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-jingle-gold/15 text-jingle-gold">
                  <Icon className="h-4.5 w-4.5" />
                </div>
                <div>
                  <p className="font-serif text-base font-semibold text-jingle-snow">
                    {t(`marketing.value.${v.key}.title`)}
                  </p>
                  <p className="mt-0.5 text-sm leading-snug text-jingle-snow/65">
                    {t(`marketing.value.${v.key}.body`)}
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
